// extracted by mini-css-extract-plugin
module.exports = {"base":"PressCheckBoxList-module-base","item":"PressCheckBoxList-module-item","text":"PressCheckBoxList-module-text","active":"PressCheckBoxList-module-active"};